class ScrollToggle {
  constructor(element) {
    this.container = element; this.toggles = this.container.querySelectorAll('.desktopScrollArrow');
    this.list = this.container.querySelector('.color-swatches') || this.container.querySelector('.ColorSwatch-slide'); this.listItems = this.list.querySelectorAll('.variant-input'); this.scrollValue = 0;
  }
  init() {
    this.toggles.forEach(toggle => { toggle.addEventListener('click', (e) => { this.move(e.target); }); })
  }
  move(target) {
    if(target.parentNode.classList.contains('desktopScrollArrow-Right')){ this.interval = setInterval(()=> { this.list.scrollLeft += (this.listItems[0].offsetWidth * 2); this.stop(); }, 1); }
    else{ this.interval = setInterval(()=> { this.list.ScrollLeft = this.scrollValue; this.list.scrollLeft -= (this.listItems[0].offsetWidth * 2); this.stop(); }, 1); }
  }
  stop() {
    if (this.list.scrollLeft > 0) { this.scrollValue = this.list.scrollLeft; }
    clearInterval(this.interval, 10);
  }
}

var ScrollerColorGroup = document.querySelectorAll('.WRapperColorCoulumnsExeution'), upsellScrollerColor = document.querySelectorAll('.CV-upsellOuter .color-swatches'), stickyScollerColor = document.querySelectorAll('.cv_sticky_atc_inner .color-swatches');
if(ScrollerColorGroup) { ScrollerColorGroup.forEach(el => { const scrollToggle = new ScrollToggle(el); scrollToggle.init(); }); }
if(upsellScrollerColor){ upsellScrollerColor.forEach(el => { const scrollToggle = new ScrollToggle(el); scrollToggle.init(); }); }
if(stickyScollerColor){ stickyScollerColor.forEach(el => { const scrollToggle = new ScrollToggle(el); scrollToggle.init(); }); }

var size_chart = document.querySelector('.tool-tip-trigger');
if(size_chart){
  size_chart.addEventListener('click',function(){
    var ModelSwiperInit = new Swiper('.swiper.models-swiper', {
      slidesPerView: 4.5,
      spaceBetween: 10,
      centeredSlides: true,
      centeredSlidesBounds:true,
      loop: true, 
      simulateTouch: true,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      breakpoints: {
        320: { slidesPerView: 2.5, },
        1024: { slidesPerView: 4.5, }
      }
    });
  })
}

var stickyATCDrawerOpen = document.querySelector('.ButtonFor-sticky.CV-mobileATC');
if(stickyATCDrawerOpen){
  stickyATCDrawerOpen.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.StickyAtc.cv_sticky_atc').classList.add('StickyPopup');
    document.querySelector('.cv_sticky_atc').style.display = 'block';
  })
}

var stickyATCDrawerClose = document.querySelector('.StickyClose');
if(stickyATCDrawerClose){
  stickyATCDrawerClose.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.StickyAtc.cv_sticky_atc').classList.remove('StickyPopup');
    document.querySelector('.cv_sticky_atc').style.display = 'none';
  })
}

var accordianToggle = document.querySelectorAll('.accordionTitle');
if(accordianToggle){
  accordianToggle.forEach(function(accordian){
    accordian.addEventListener('click',function(e){
      e.preventDefault();
      var objj = this;
      document.querySelectorAll('.accordionTitle').forEach(function(title){
        if(title != objj){ title.parentNode.classList.remove('active'); }
      })
      this.parentNode.classList.toggle('active');
    })
  })
}

var sizeCalcStickyBehavior = document.querySelector('.NotSure-link');
if(sizeCalcStickyBehavior){
  sizeCalcStickyBehavior.addEventListener('click',function(e){
    e.preventDefault();
    if(window.innerWidth > 749){
      const element = document.querySelector(".pdp_variants_MN.DeskMNInit");
      element.scrollIntoView({ behavior : 'smooth' });
      setTimeout(function(){ document.body.classList.add('highlightCalculator'); },700);
      setTimeout(function(){ document.body.classList.remove('highlightCalculator'); },3300);
    }else{
      document.body.classList.add('body_Mobile_Dropdown');
      document.querySelector('.MobileDropdown').classList.add('Mobile_Dropdown');
      document.querySelector('.StickyAtc.cv_sticky_atc').classList.remove('StickyPopup');
      document.querySelector('.cv_sticky_atc').style.display = 'none';
    }
  })
}

var upsellVariant = document.querySelectorAll('.upsell-form .variant-input input.CustomWrapper');
if(upsellVariant){
  upsellVariant.forEach(function(input){
    input.addEventListener('click',function(){
      var GETColorName = this.value;
      if(this.closest('.variant-input').querySelector('.ProductForm__Label')){
        var ColorType = this.closest('.variant-input').querySelector('.ProductForm__Label').innerHTML;
        this.closest('.ColorItems').querySelector('span.Limited-Edition.for-upsell-section').innerHTML = ColorType;
      }
      if(this.closest('.ColorItems')){ this.closest('.ColorItems').querySelector('[data-color-label]').innerHTML = GETColorName; }
    })
  })
}

var upsellVrntWrpr = document.querySelectorAll('.upsell-meta .variant-wrapper input.CustomWrapper');
if(upsellVrntWrpr){
  var text = '', option1, option2, comboOpt, getQuantity, getImage, discount, price, current_price_formatted;
  upsellVrntWrpr.forEach(function(input){
    input.addEventListener('change',function(){
      this.closest('.upsell-form').querySelectorAll('.all_variants option').forEach(function(option){ option.selected = false; option.removeAttribute('selected'); })
      option1=this.closest('.upsell-form').querySelector('[data-index="option1"] input:checked').value;
      option2=this.closest('.upsell-form').querySelector('[data-index="option2"] input:checked').value;
      comboOpt = option1+' / '+option2;
      if(this.closest('.upsell-form').querySelector('.all_variants option[variant-title="'+comboOpt+'"]')){
        price = parseInt(this.closest('.upsell-form').querySelector('.all_variants option[variant-title="'+comboOpt+'"]').dataset.price);
        discount = parseInt(100 - this.closest('.upsell-form').querySelector('.all_variants option[variant-title="'+comboOpt+'"]').dataset.discount);
      
        current_price_formatted = theme.Currency.formatMoney(price, theme.settings.moneyFormat)
        if(this.closest('.upsell-form').querySelector('.all_variants option[variant-title="'+comboOpt+'"]').dataset.discount > 0){
          let discountedPrice = price * (discount/100), DiscPriceWithMoney = theme.Currency.formatMoney(discountedPrice, theme.settings.moneyFormat);
          if(this.closest('.upsell-meta.CV-upsell-meta').querySelector('.upsell-price.priceContainerMN.discountedPrice')){
            this.closest('.upsell-meta.CV-upsell-meta').querySelector('.upsell-price.priceContainerMN.discountedPrice').innerHTML = `<s>${current_price_formatted}</s><span style="color:red;">${DiscPriceWithMoney}</span>`
          }
        }else{
          if(this.closest('.upsell-meta.CV-upsell-meta').querySelector('.upsell-price.priceContainerMN.discountedPrice')){
            this.closest('.upsell-meta.CV-upsell-meta').querySelector('.upsell-price.priceContainerMN.discountedPrice').innerHTML = `${current_price_formatted}`
          }
        }
      }
      
      if( this.closest('.upsell-form').querySelector('.all_variants option[variant-title="'+comboOpt+'"]') == null ){
          this.closest('.upsell-form').querySelector('[type="submit"]').setAttribute('disabled','disabled');
          this.closest('.upsell-form').querySelector('[type="submit"] span').innerHTML = 'UNAVAILABLE';        
      }else{
        this.closest('.upsell-form').querySelector('.all_variants option[variant-title="'+comboOpt+'"]').selected = true;
        this.closest('.upsell-form').querySelector('.all_variants option[variant-title="'+comboOpt+'"]').setAttribute('selected','selected');
        getQuantity = this.closest('.upsell-form').querySelector('.all_variants option[variant-title="'+comboOpt+'"]').getAttribute('var_qty');
        getImage = this.closest('.upsell-form').querySelector('.all_variants option[variant-title="'+comboOpt+'"]').getAttribute('var-image');
        this.closest('.CV-upsellOuter').querySelector('.upsell-image img').setAttribute('src',getImage);
        this.closest('.CV-upsellOuter').querySelector('.upsell-image img').setAttribute('srcset',getImage);
        if(getQuantity > 0){
          this.closest('.upsell-form').querySelector('[type="submit"]').removeAttribute('disabled');
          this.closest('.upsell-form').querySelector('[type="submit"] span').innerHTML = 'ADD TO CART';
        }else if(getQuantity < 1){
          this.closest('.upsell-form').querySelector('[type="submit"]').setAttribute('disabled','disabled');
          this.closest('.upsell-form').querySelector('[type="submit"] span').innerHTML = 'SOLD OUT';
        }else if(!this.closest('.upsell-form').querySelector('.all_variants option[variant-title="'+comboOpt+'"]')){
          this.closest('.upsell-form').querySelector('[type="submit"]').setAttribute('disabled','disabled');
          this.closest('.upsell-form').querySelector('[type="submit"] span').innerHTML = 'UNAVAILABLE';
        }
      }
      
    })
  })
}

var upsellWrprLabel = document.querySelectorAll('.upsell-item-wrap');
if(upsellWrprLabel.length > 0){
  upsellWrprLabel.forEach(function(upsell){
    var selectedLabel = upsell.querySelector('[data-index="option1"] .variant-input input:checked').closest('.variant-input').querySelector('.ProductForm__Label').innerHTML;
    upsell.querySelector('span.Limited-Edition.for-upsell-section').innerHTML = selectedLabel;
  })
}

var UnderwearSizePop = document.querySelectorAll('[JSUNDERSIZEPOP]'), UnderwearPopClose = document.querySelectorAll('[JSUNDERSIZEPOPClOSE]'), UnderwearPopOverlay = document.querySelectorAll('.overlayUnderPop');
if(UnderwearSizePop){ UnderwearSizePop.forEach(function(popup){ popup.addEventListener('click',function(e){ e.preventDefault(); document.querySelector('[JSUNDERSIZEPOPCNT]').classList.add('pop_active'); document.body.classList.add('underwear_pop_active'); }) }) }
if(UnderwearPopClose){ UnderwearPopClose.forEach(function(close){ close.addEventListener('click',function(e){ e.preventDefault(); document.querySelector('[JSUNDERSIZEPOPCNT]').classList.remove('pop_active'); document.body.classList.remove('underwear_pop_active'); }) }) }
if(UnderwearPopOverlay){ UnderwearPopOverlay.forEach(function(overlay){ overlay.addEventListener('click',function(e){ document.querySelector('[JSUNDERSIZEPOPCNT]').classList.remove('pop_active'); document.body.classList.remove('underwear_pop_active'); }) }) }

// Reduced frequency from 20ms to 200ms for better performance (10x improvement)
setInterval(function(){
  if(document.querySelector('#CartDrawerSpecialInstructions')){
    var NotesHTML = document.querySelector('#CartDrawerSpecialInstructions');
    NotesHTML = NotesHTML.value; NotesHTML = NotesHTML.trim();
    let lastChar = NotesHTML.charAt(NotesHTML.length - 1), firstChar = NotesHTML.substring(0, 1);
    if(firstChar == '|' && lastChar == '|'){ var trimHTml = NotesHTML.slice(1,-1); trimHTml = trimHTml.trim(); document.querySelector('#CartDrawerSpecialInstructions').innerHTML = trimHTml; }
    var splitValAll = NotesHTML.split('|'), allMerger = [], EvelynTradArray = [], EvelynMeasArray = [], BobbieTradArray = [], BobbieMeasArray = [], DefyTradArray = [], DefyMeasArray = [], StarletteTradArray = [], StarletteMeasArray = [],
        BeyondTradArray = [], BeyondMeasArray = [], SmoothTradArray = [], SmoothMeasArray = [], RetroTradArray = [], RetroMeasArray = [], ThongTradArray = [], ThongMeasArray = [], LonglineTradArray = [], 
        LonglineMeasArray = [], SlipTradArray = [], SlipMeasArray = [];
    
    splitValAll.forEach(function(splitVal){
      if((splitVal.includes('Evelyn')) && (splitVal.includes('Traditional'))){ splitVal = splitVal.trim(); EvelynTradArray.push(splitVal) }
      if((splitVal.includes('Evelyn')) && (splitVal.includes('Measurement'))){ splitVal = splitVal.trim(); EvelynMeasArray.push(splitVal) }
      if((splitVal.includes('Starlette')) && (splitVal.includes('Traditional'))){ splitVal = splitVal.trim(); StarletteTradArray.push(splitVal) }
      if((splitVal.includes('Starlette')) && (splitVal.includes('Measurement'))){ splitVal = splitVal.trim(); StarletteMeasArray.push(splitVal) }
      if((splitVal.includes('Bobbie')) && (splitVal.includes('Traditional'))){ splitVal = splitVal.trim(); BobbieTradArray.push(splitVal) }
      if((splitVal.includes('Bobbie')) && (splitVal.includes('Measurement'))){ splitVal = splitVal.trim(); BobbieMeasArray.push(splitVal) }
      if((splitVal.includes('Beyond')) && (splitVal.includes('Traditional'))){ splitVal = splitVal.trim(); BeyondTradArray.push(splitVal) }
      if((splitVal.includes('Beyond')) && (splitVal.includes('Measurement'))){ splitVal = splitVal.trim(); BeyondMeasArray.push(splitVal) }
      if((splitVal.includes('Defy')) && (splitVal.includes('Traditional'))){ splitVal = splitVal.trim(); DefyTradArray.push(splitVal) }
      if((splitVal.includes('Defy')) && (splitVal.includes('Measurement'))){ splitVal = splitVal.trim(); DefyMeasArray.push(splitVal) }
      if((splitVal.includes('Smoothing')) && (splitVal.includes('Traditional'))){ splitVal = splitVal.trim(); SmoothTradArray.push(splitVal) }
      if((splitVal.includes('Smoothing')) && (splitVal.includes('Measurement'))){ splitVal = splitVal.trim(); SmoothMeasArray.push(splitVal) }
      if((splitVal.includes('Retro')) && (splitVal.includes('Traditional'))){ splitVal = splitVal.trim(); RetroTradArray.push(splitVal) }
      if((splitVal.includes('Retro')) && (splitVal.includes('Measurement'))){ splitVal = splitVal.trim(); RetroMeasArray.push(splitVal) }
      if((splitVal.includes('Thong')) && (splitVal.includes('Traditional'))){ splitVal = splitVal.trim(); ThongTradArray.push(splitVal) }
      if((splitVal.includes('Thong')) && (splitVal.includes('Measurement'))){ splitVal = splitVal.trim(); ThongMeasArray.push(splitVal) }
      if((splitVal.includes('Longline')) && (splitVal.includes('Traditional'))){ splitVal = splitVal.trim(); LonglineTradArray.push(splitVal) }
      if((splitVal.includes('Longline')) && (splitVal.includes('Measurement'))){ splitVal = splitVal.trim(); LonglineMeasArray.push(splitVal) }
      if((splitVal.includes('Slip')) && (splitVal.includes('Traditional'))){ splitVal = splitVal.trim(); SlipTradArray.push(splitVal) }
      if((splitVal.includes('Slip')) && (splitVal.includes('Measurement'))){ splitVal = splitVal.trim(); SlipMeasArray.push(splitVal) }
    })

    // Bra Properties
    if(EvelynTradArray.length > 0){ allMerger.push(EvelynTradArray[0]) }; if(EvelynMeasArray.length > 0){ allMerger.push(EvelynMeasArray[0]) };
    if(StarletteTradArray.length > 0){ allMerger.push(StarletteTradArray[0]) }; if(StarletteMeasArray.length > 0){ allMerger.push(StarletteMeasArray[0]) };
    if(BobbieTradArray.length > 0){ allMerger.push(BobbieTradArray[0]) }; if(BobbieMeasArray.length > 0){ allMerger.push(BobbieMeasArray[0]) };
    if(BeyondTradArray.length > 0){ allMerger.push(BeyondTradArray[0]) }; if(BeyondMeasArray.length > 0){ allMerger.push(BeyondMeasArray[0]) };
    if(DefyTradArray.length > 0){ allMerger.push(DefyTradArray[0]) }; if(DefyMeasArray.length > 0){ allMerger.push(DefyMeasArray[0]) };
    if(SmoothTradArray.length > 0){ allMerger.push(SmoothTradArray[0]) }; if(SmoothMeasArray.length > 0){ allMerger.push(SmoothMeasArray[0]) };

    // Underwear Properties
    if(RetroTradArray.length > 0){ allMerger.push(RetroTradArray[0]) }; if(RetroMeasArray.length > 0){ allMerger.push(RetroMeasArray[0]) };
    if(ThongTradArray.length > 0){ allMerger.push(ThongTradArray[0]) }; if(ThongMeasArray.length > 0){ allMerger.push(ThongMeasArray[0]) };
    if(LonglineTradArray.length > 0){ allMerger.push(LonglineTradArray[0]) }; if(LonglineMeasArray.length > 0){ allMerger.push(LonglineMeasArray[0]) };
    if(SlipTradArray.length > 0){ allMerger.push(SlipTradArray[0]) }; if(SlipMeasArray.length > 0){ allMerger.push(SlipMeasArray[0]) };
  
    var joinAllVal = allMerger.join(' | '); if(document.querySelector('#CartDrawerSpecialInstructions').innerHTML != joinAllVal){document.querySelector('#CartDrawerSpecialInstructions').innerHTML = joinAllVal}
  }
},200)

function openTab(target, tab){
  if(target.nextElementSibling){ target.nextElementSibling.classList.remove('active'); }else if(target.previousElementSibling){ target.previousElementSibling.classList.remove('active'); }
  target.closest('.Know-size').querySelectorAll('.tab.CalWrapper').forEach(function(sizeTab){ sizeTab.style.display = 'none'; });
  target.classList.add('active');
  target.closest('.Know-size').querySelector('#'+tab).style.display = 'block';
}